module.exports = __webpack_public_path__ + "static/media/ui_image.5f664acf.png";